import React, { useState, useEffect } from "react";

const treatmentOptions = [
  "Acne",
  "Rash", 
  "Eczema/Atopic Dermatitis",
  "Psoriasis",
  "Mole or other spot",
  "Hair loss",
  "Other/Unsure"
];

const TreatmentQuestion = ({ onSubmit, onNext, initialValue }) => {
  const [selectedTreatment, setSelectedTreatment] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (initialValue) {
      setSelectedTreatment(initialValue);
    }
  }, [initialValue]);

  const handleTreatmentChange = (treatment, event) => {
    // Blur the button after click to prevent focus from persisting and looking like selection
    if (event && event.currentTarget) {
      event.currentTarget.blur();
    }
    setSelectedTreatment(treatment);
    // Don't call onSubmit here - only when Continue is clicked
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedTreatment) return;
    
    onSubmit(selectedTreatment);
    onNext();
    
    // Reset selection
    setSelectedTreatment("");
  };

  const canSubmit = selectedTreatment !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="treatment-options-container">
        <div className="treatment-options">
          {treatmentOptions.map((option) => (
            <button
              key={option}
              type="button"
              className={`treatment-button ${selectedTreatment === option ? 'treatment-button-selected' : ''}`}
              onClick={(e) => handleTreatmentChange(option, e)}
            >
              {option}
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="treatment-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default TreatmentQuestion; 